import { useState, useEffect, forwardRef } from "react";
import { LuckyWheel } from "@lucky-canvas/react"; // API https://100px.net/docs/wheel.html
import defaultBg from "./img/bg.png";
import styles from "./style.module.less";
import defaultPointerImg from "./img/pointer.png";
import useCreatDivider from "./useCreatDivider";
import { merge, cloneDeep } from "lodash-es";
import { LuckyWheelProps } from "./type";
import { transformFieldsToPx, toPx } from "@/utils/tools";

export * from "./type";

const getDefaultConfig = (prizesCount: number) => {
  return {
    blocks: [
      {
        padding: "20px",
        rotate: 0,
        width: "100%",
        height: "100%",
      },
    ],
    prizes: [],
    buttons: [
      {
        radius: "30%",
        background: "transparent",
        pointer: true,
        fonts: [{ text: "", top: "-10px" }],
      },
    ],
    defaultConfig: {
      offsetDegree: 360 / prizesCount / 2,
    },
  };
};

const Wheel = forwardRef<HTMLLIElement, LuckyWheelProps>((props, ref) => {
  const WIDTH = toPx("600rem");
  const HEIGHT = toPx("600rem");

  const { prizes, winText } = props;
  const prizesCount = prizes.length;
  const defaultWheelConfig = getDefaultConfig(prizesCount);

  const { getDividersImg, canvasRef } = useCreatDivider();
  const [wheelConfig, setWheelConfig] = useState({});
  const config = transformFieldsToPx(
    merge(defaultWheelConfig, merge(cloneDeep(props), wheelConfig)),
  );
  const luckyWheelKey = prizesCount;

  useEffect(() => {
    // 创建分割线
    const divImg = getDividersImg(prizesCount);
    setWheelConfig((b) => {
      return {
        ...merge(b, {
          blocks: [
            {
              imgs: [
                {
                  src: divImg,
                  width: "100%",
                  height: "100%",
                  rotate: true,
                },
              ],
            },
          ],
        }),
      };
    });

    return () => {
      if (canvasRef.current) {
        const ctx = canvasRef.current.getContext("2d");
        ctx?.clearRect(0, 0, canvasRef.current.width, canvasRef.current.height);
      }
    };
  }, [prizesCount]);

  const bgImg = props?.blocks?.[0]?.imgs?.[0]?.src || defaultBg;
  const pointerImg = props?.pointerImg?.src || defaultPointerImg;

  return (
    <div
      className={styles["xply-wheel"]}
      style={{ backgroundImage: `url(${bgImg})` }}
    >
      {/* 创建分割线 canvas */}
      <canvas
        className={styles["dividerCanvas"]}
        ref={canvasRef}
        width={WIDTH}
        height={HEIGHT}
      ></canvas>

      <div className={styles["wrapper"]}>
        {/* 指针 */}
        <div
          className={styles["pointer"]}
          style={{
            top: props?.pointerImg?.top,
            width: props?.pointerImg?.width,
            height: props?.pointerImg?.height,
          }}
        >
          <img src={pointerImg} alt="指针" />
        </div>

        {/* 显示中奖信息 */}
        <div className={styles["buttonText"]}>{winText}</div>

        <LuckyWheel
          key={luckyWheelKey}
          ref={ref}
          {...config}
          width={WIDTH}
          height={HEIGHT}
        />
      </div>
    </div>
  );
});

export default Wheel;
